<template>
    <div class="container">
        <div class="title-box">
            <h1 class="title-text">当サイト掲載業者の</h1>
        </div>
        <div class="selection-criteria-box">
            <span class="number">5</span>
            <span class="text-and-criteria-wrapper">
                <span class="text">つの</span>
                <span class="criteria-text">選定基準</span>
            </span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'GutterDesign',
};
</script>

<style scoped>
.container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: #fff9f1;
    padding-top: 20px;
    background: #2437a3;
    /* margin-top: 20px; */
}

.title-box {
    color: white;
}

.title-text {
    font-size: 26px;
    font-weight: bold;
    margin: 0;
    letter-spacing: 2px;
    padding-bottom: 10px;
}

.selection-criteria-box {
    display: flex;
    align-items: baseline;
    color: white;
    margin-top: -20px;
}

.number {
    font-size: 6rem;
    font-weight: bold;
    color: #ffc107;
    /* text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3); */
    line-height: 1;
}

.criteria-text {
    font-size: 3rem;
    font-weight: bold;
    color: #ffc107;
    /* text-shadow: 2px 2px 4px #0000004d; */
    margin-right: 10px;
    line-height: 1;
}

.text-and-criteria-wrapper {
    transform: translateY(-20px);
}

.text {
    font-size: 2.5rem;
    font-weight: bold;
    color: white;
    /* text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.3); */
}

/* ==================== スマホ対応 ==================== */
@media (max-width: 600px) {
    .title-text {
        font-size: 1.8rem;
    }

    .text {
        font-size: 2rem;
    }

    .criteria-text {
        font-size: 2.5rem;
    }

    .number {
        font-size: 5rem;
    }
}

/* ==================== スマホ対応 ==================== */
@media (max-width: 480px) {
    .title-text {
        font-size: 1.6rem;
    }

    .text {
        font-size: 2rem;
    }

    .criteria-text {
        font-size: 2.5rem;
    }

    .number {
        font-size: 5rem;
    }
}
</style>